// 领券事件名称
export const getGiftEventName = (giftId) => `onclick_gift_${giftId}`;
// 列表点击事件名称
export const getOnClickEventName = (recallBizId, giftId = '') => {
    return giftId
        ? `onclick_show_list_${recallBizId}_${giftId}`
        : `onclick_show_list_${recallBizId}`;
};
// 列表底部的提示getBottomTipID通过getBottomTipID获得
export const getBottomTipID = (recallBizId, giftId = '') => {
    return giftId ? `bottom_tip_${recallBizId}_${giftId}` : `bottom_tip_${recallBizId}`;
};
// 列表容器getPoiContainerID通过getPoiContainerID获得
export const getPoiContainerID = (recallBizId, giftId = '') => {
    return giftId ? `poi_container_${recallBizId}_${giftId}` : `poi_container_${recallBizId}`;
};
